module.exports = __webpack_public_path__ + "static/media/cq_aggiorna_dati.4a2f46b3.svg";